import React, { useState } from "react";
import { CustomTextField } from "./CustomeTextField"
import { InputAdornment } from "@mui/material"
import SearchIcon from '@mui/icons-material/Search';
import { URL} from '../config'

const SearchField = ({setVideos}) => {
    const [debounce, setDebounce] = useState();

  const performSearch = async (value) => {
    try {
      let url = URL+'/v1/videos'
      if(value.length > 0)
        url += '?title='+value;
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      setVideos(data.videos);
    } catch (error) {
      console.log('error')
      console.log(error);
    }
  }

  const handleSearch = (e) => {
    debounceSearch(e.target.value);
  }

  const debounceSearch = (value) => {
    if(debounce) clearTimeout(debounce);

    const debounceCall = setTimeout(() => {
                            performSearch(value);
                          }, 1000);
    setDebounce(debounceCall);                     
  }
  return (
    <>
        <CustomTextField
        placeholder="Search here"
        size="small"
        InputProps={{
            endAdornment: (
            <InputAdornment position="end">
                <SearchIcon />
            </InputAdornment>
            ),
        }}
        onChange={handleSearch}
        />
    </>
  );
};

export default SearchField;
